'use client';

import dynamic from 'next/dynamic';
import React from 'react';

// Lazy load the SEO component
const LazyProductArchitectureSEO = dynamic(
  () => import('./ProductArchitectureSEO'),
  {
    ssr: false, // Keep consistent with Shadow DOM component
    loading: () => (
      <div className="flex items-center justify-center h-[400px] my-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4" />
          <p className="text-gray-600">Loading SEO architecture...</p>
        </div>
      </div>
    )
  }
);

// Wrapper with intersection observer for true lazy loading
export default function LazyProductArchitectureSEOWrapper(props: any) {
  const [shouldLoad, setShouldLoad] = React.useState(false);
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      {
        // Load when component is 200px away from viewport
        rootMargin: '200px',
        threshold: 0
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef}>
      {shouldLoad ? (
        <LazyProductArchitectureSEO {...props} />
      ) : (
        <div className="flex items-center justify-center h-[400px] my-8">
          <div className="text-center text-gray-400">
            <p className="text-sm">SEO architecture will load when visible</p>
          </div>
        </div>
      )}
    </div>
  );
}